import type { Testimonial } from '../types/content'

export const testimonials: Testimonial[] = [
  {
    quote:
      'Amoye is the first call I make before a board meeting and the last call I make before a hard decision. She sees the company I am building and the person I am becoming at the same time.',
    name: 'Tunde Bakare',
    role: 'Co-founder & CEO, Kora Labs',
    group: 'Founder',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/e6576017-85a2-446b-85f9-81e4b7417ffd.jpg',
  },
  {
    quote:
      'She has the rarest combination in this industry — genuine operating scar tissue and real investment discipline. Our portfolio is measurably better because she is in the room.',
    name: 'Priya Raghunathan',
    role: 'Managing Partner, Aleph Capital',
    group: 'Investor',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/f833e2fe-dfa9-4961-bd4a-f40a315926fe.jpg',
  },
  {
    quote:
      'We had spent three years and a great deal of money on innovation that produced nothing. Amoye reset the entire model in a quarter and shipped five products with us in the year that followed.',
    name: 'Martin Ashworth',
    role: 'Group Chief Strategy Officer, Meridian Bank',
    group: 'Corporate',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/3540b579-92e0-4fbf-8076-7a6885fbae05.jpg',
  },
]

export const testimonialGroups = ['All', 'Founder', 'Investor', 'Corporate'] as const
